<template>
    <div>  
        <div v-if="loading1 || loading2" class="pl-5 pt-5">
            <h2 class="mt-3 ml-3">Cargando...</h2>
        </div>
        <div v-else class="vx-row flex justify-center">
            <div class="vx-col vx-col sm:w-4/5 lg:w-2/3 md:w-3/4 px-4 py-6 my-5">
                <vx-card title="" >

                    <div slot="no-body">
                        <img src="@/assets/images/pages/login.png" alt="content-img" class="responsive card-img-top">
                    </div>
                    
                    <div>
                        <h5>Nueva Cita Médica</h5>
                        <p class="mt-2">¡Hola! Por favor completa la siguiente información para agendar tu consulta</p>
                    </div>

                    <div class="mt-5">
                        <form-wizard color="rgba(var(--vs-primary), 1)"
                            :title="null" :subtitle="null"
                            @on-complete="formSubmitted"
                            backButtonText="Regresar"
                            next-button-text="Siguiente"
                            finishButtonText="Agendar Cita"
                        >
                            <tab-content title="Información" class="mb-5" :before-change="firstStep">

                                <!-- tab 1 content -->
                                <div class="vx-row">
                                    
                                    <div class="vx-col  w-full mt-5">
                                        <h4>Datos del paciente</h4>
                                    </div>
                                    <div class="vx-col  w-full mt-5 ml-4">
                                        <h6 class="inline mr-2">Nombres:</h6><p class="inline">
                                            {{currentPatientData.first_name}}
                                        </p>
                                    </div>
                                    <div class="vx-col  w-full mt-5 ml-4">
                                        <h6 class="inline mr-2">Apellidos:</h6><p class="inline">
                                            {{currentPatientData.last_name}}
                                        </p>
                                    </div>
                                    <div class="vx-col  w-full mt-5 ml-4">
                                        <h6 class="inline mr-2">Correo Electrónico:</h6><p class="inline">
                                            {{currentPatientData.email}}
                                        </p>
                                    </div>
                                     <div class="vx-col  w-full mt-5 ml-4" v-if="currentPatientData.phone[0]">
                                        <h6 class="inline mr-2">Teléfono:</h6><p class="inline">
                                            {{currentPatientData.phone[0]}}
                                        </p>
                                    </div>
                                    <vs-divider></vs-divider>
                                    <div class="vx-col  w-full mt-5">
                                        <h4>Datos del doctor</h4>
                                    </div>
                                    <div class="vx-col  w-full mt-5 ml-4">
                                        <h6 class="inline mr-2">Nombres:</h6><p class="inline">
                                            {{currentDoctorData.first_name}}
                                        </p>
                                    </div>
                                    <div class="vx-col  w-full mt-5 ml-4">
                                        <h6 class="inline mr-2">Apellidos:</h6><p class="inline">
                                            {{currentDoctorData.last_name}}
                                        </p>
                                    </div>
                                    <div class="vx-col  w-full mt-5 ml-4">
                                        <h6 class="inline mr-2">Correo Electrónico:</h6><p class="inline">
                                            {{currentDoctorData.email}}
                                        </p>
                                    </div>
                                    <div class="vx-col  w-full mt-5 ml-4" v-if="currentDoctorData.phone[0]">
                                        <h6 class="inline mr-2">Teléfono:</h6><p class="inline">
                                            {{currentDoctorData.phone[0]}}
                                        </p>
                                    </div>
                                    
                                </div>
                            </tab-content>

                            <!-- tab 2 content -->
                            <tab-content title="Cita Médica" class="mb-5" :before-change="validateCitaMed">
                                <form data-vv-scope="cita-med">
                                    <div class="vx-row">
                                        <div class="vx-col  w-full mt-5">
                                            <h5>Motivo de la Consulta</h5>
                                        </div>
                                        <div class="vx-col  w-full mt-5">
                                            <p>Explique todos los síntomas y/o motivos para su consulta.</p>
                                        </div>
                                        <div class="vx-col sm:w-full md:w-2/3 w-full">
                                            <vs-textarea v-model="consultationDetail.comments_obs" v-validate="'required'" name="motivo_consulta" label="Descripción del Motivo de Consulta" class="mb-0 md:mt-10 mt-6" rows="3" />
                                            <span class="text-danger w-full">{{ errors.first('cita-med.motivo_consulta') }}</span>
                                            <small class="w-full"><br>Para agendar la reserva debe indicar un motivo de consulta.</small>
                                        </div>
                                        <div class="vx-col sm:w-full md:w-1/3 pt-3 w-full">
                                            <h6>Síntomas COVID</h6>
                                            <ul class="centerx ml-4">
                                                <!-- <li>
                                                    <vs-checkbox class="mt-4 mb-2" v-model="consultationDetail.main_symptoms.pressure">Presión alta</vs-checkbox>
                                                </li>
                                                <li>
                                                    <vs-checkbox class="mb-2" v-model="consultationDetail.main_symptoms.fever">Fiebre</vs-checkbox>
                                                </li>
                                                <li>
                                                    <vs-checkbox class="mb-2" v-model="consultationDetail.main_symptoms.nausea">Nausea</vs-checkbox>
                                                </li>
                                                <li>
                                                    <vs-checkbox class="mb-2" v-model="consultationDetail.main_symptoms.tiredness">Cansancio</vs-checkbox>
                                                </li>
                                                <li>
                                                    <vs-checkbox class="mb-2" v-model="consultationDetail.main_symptoms.fatigue">Fatiga</vs-checkbox>
                                                </li> -->
                                                <li>
                                                    <vs-checkbox class="mt-4 mb-2" v-model="consultationDetail.main_symptoms.fever">Fiebre</vs-checkbox>
                                                </li>
                                                <li>
                                                    <vs-checkbox class="mt-4 mb-2" v-model="consultationDetail.main_symptoms.dryCough">Tos Seca</vs-checkbox>
                                                </li>
                                                <li>
                                                    <vs-checkbox class="mt-4 mb-2" v-model="consultationDetail.main_symptoms.tiredness">Cansancio</vs-checkbox>
                                                </li>
                                                <li>
                                                    <vs-checkbox class="mt-4 mb-2" v-model="consultationDetail.main_symptoms.throatPain">Dolor de Garganta</vs-checkbox>
                                                </li>
                                                <li>
                                                    <vs-checkbox class="mt-4 mb-2" v-model="consultationDetail.main_symptoms.diarrhea">Diarrea</vs-checkbox>
                                                </li>
                                                <li>
                                                    <vs-checkbox class="mt-4 mb-2" v-model="consultationDetail.main_symptoms.headache">Dolor de Cabeza</vs-checkbox>
                                                </li>
                                                <li>
                                                    <vs-checkbox class="mt-4 mb-2" v-model="consultationDetail.main_symptoms.smellTasteLoss">Perdida del sentido del olfato o del gusto</vs-checkbox>
                                                </li>
                                                <li>
                                                    <vs-checkbox class="mt-4 mb-2" v-model="consultationDetail.main_symptoms.breathingDifficulty">Dificultad para respirar</vs-checkbox>
                                                </li>
                                            </ul>
                                        </div>
                                        <vs-divider></vs-divider>
                                        <div class="vx-col  w-full mt-5">
                                            <vs-checkbox class="mt-4 mb-4" v-model="consultationDetail.previousConsultation">Es seguimiento de otra consulta?</vs-checkbox>
                                        </div>
                                        <div v-if="!consultationDetail.previousConsultation == true">
                                        <vs-row vs-w="12" class="my-3 px-3" >
                                            <vs-col vs-type="flex" vs-justify="flex-start" vs-align="flex-start" vs-w="6">
                                            <h5>Preguntas del Doctor</h5>
                                            </vs-col>
                                        </vs-row>
                                        <vs-row class="px-3 mt-2" vs-w="12" v-for="(question, key) in customQuestions" :key="key"  >
                                            <vs-col vs-type="flex" vs-justify="flex-start" vs-align="flex-start" vs-w="12" v-if="question.active">
                                            <div class="vx-col w-full">
                                                <p>{{question.title}}</p>
                                                <vs-textarea v-bind:readonly="isReadOnly" v-model="customQuestionsAnswers[key]" :label="question.instructions" class="mb-3" rows="1" />
                                            </div>
                                            </vs-col>
                                        </vs-row>
                                        </div>
                                        <vs-divider></vs-divider>
                                        <div class="vx-col  w-full mt-6">
                                            <h4 class="my-4">Datos de la Reserva</h4>
                                        </div>
                                        <div class="vx-col  w-full mt-2 mb-3">
                                            <h5 class="my-2">Clínica</h5>
                                            <v-select class="w-full" :options="docClinics" label="title" 
                                                v-validate="'required'"  name="clinica" 
                                                :reduce="option => option.id"  v-model="eventData.clinic_id" :dir="$vs.rtl ? 'rtl' : 'ltr'"
                                                :selectable="option => !(option.meta.zoom_active && option.meta.zoom_active.toLowerCase() == 'false')"
                                                >
                                                    <template v-slot:option="option">
                                                        <img class="mr-2 inline"  :src=" option.meta.type.toLowerCase() == 'virtual' ? 
                                                        'https://img.icons8.com/ios/24/000000/zoom.png' :
                                                        'https://img.icons8.com/material-outlined/24/000000/hospital-3.png' "/>
                                                        <p class="inline"
                                                        :class="(option.meta.type.toLowerCase() == 'virtual') && (option.meta.zoom_active) && !(option.meta.zoom_active == 'true')
                                                            ? 'text-danger' : 'text-primary'"
                                                        >{{ 
                                                        (option.meta.type.toLowerCase() == 'virtual')
                                                        && (option.meta.zoom_active) && !(option.meta.zoom_active == 'true')
                                                        ?  `${option.title} - Sin Activar` : option.title
                                                        }}</p>
                                                    </template>
                                                </v-select> 
                                            <span class="text-danger">{{ errors.first('cita-med.clinica') }}</span>
                                        </div>
                                        <div class="vx-row w-full mt-3 pl-3">
                                            <div class="vx-col w-1/2 ">
                                                <h5 class="my-2">Fecha</h5>
                                                <flat-pickr class="w-full" :config="configdateTimePicker" v-model="eventData.date" placeholder="Fecha"
                                                    v-validate="'required'" name="fecha" />
                                                <span class="text-danger w-full">{{ errors.first('cita-med.fecha') }}</span>
                                            </div>
                                            <div class="vx-col w-1/2 ">
                                                <h5 class="my-2">Hora</h5>
                                                <v-select v-if="eventData.date && eventData.clinic_id" :options="clinicAvailabilityByDate" :dir="$vs.rtl ? 'rtl' : 'ltr'"
                                                name="hora" v-validate="'required'" class="w-full style-chooser"  v-model="eventData.hour" 
                                                    :reduce="option => new Date(option.date1).toISOString().split('T')[1].substring(0,5)"
                                                    :selectable="option => option.available"
                                                >
                                                <template slot="selected-option" slot-scope="option">
                                                    {{ `${convertUTC_TIME(option.date1)} - ${convertUTC_TIME(option.date2)}` }}
                                                </template>
                                                    <template v-slot:option="option">
                                                    <p class="inline" :class="option.available ? 'text-primary' : 'text-danger'">{{ 
                                                        `${convertUTC_TIME(option.date1)} - ${convertUTC_TIME(option.date2)}`
                                                    }}</p>
                                                    <small v-if="!option.available" class="ml-2 text-danger">
                                                        No Disponible
                                                    </small>
                                                    </template>
                                                </v-select>
                                                <p class="my-1 text-secondary" v-else >Selecciona una fecha y clínica para determinar la disponibilidad</p>
                                                <span class="text-danger">{{ errors.first('cita-med.hora') }}</span>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </tab-content>

                            <!-- tab 3 content -->
                            <tab-content title="Confirmación" class="mb-5">
                                <div class="vx-row">
                                     <div class="vx-col  w-full mt-5">
                                        <h5>Doctor</h5>
                                    </div>
                                    <div class="vx-col  w-full mt-5 ml-4">
                                        <h6 class="inline mr-2">Nombres:</h6><p class="inline">
                                            {{currentDoctorData.first_name}}
                                        </p>
                                    </div>
                                    <div class="vx-col  w-full mt-5 ml-4">
                                        <h6 class="inline mr-2">Apellidos:</h6><p class="inline">
                                            {{currentDoctorData.last_name}}
                                        </p>
                                    </div>
                                    <div class="vx-col  w-full mt-5 ml-4">
                                        <h6 class="inline mr-2">Correo Electrónico:</h6><p class="inline">
                                            {{currentDoctorData.email}}
                                        </p>
                                    </div>
                                    <vs-divider></vs-divider>
                                    <div class="vx-col  w-full mt-5">
                                        <h5>Motivo de la Consulta</h5>
                                    </div>
                                    <div class="vx-col  w-full">
                                        <p class="ml-4"> {{ consultationDetail.comments_obs ? consultationDetail.comments_obs : 'N/A' }} </p>
                                    </div>
                                    <div class="vx-col  w-full mt-5">
                                        <h5>Fecha y Hora</h5>
                                        <p class="mt-2 ml-4">{{timeSTR}}</p>
                                    </div>
                                    <div class="vx-col  w-full mt-5">
                                        <h5>Clínica</h5>
                                    </div>
                                    <div class="vx-col  w-full">
                                        <p class="ml-4">{{activeClinic}}</p>
                                    </div>
                                </div>
                            </tab-content>
                        </form-wizard>
                    </div>
                </vx-card>
            </div>
        </div>
    </div>
</template>

<script>
import {FormWizard, TabContent} from 'vue-form-wizard'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import Datepicker from 'vuejs-datepicker';
import vSelect from 'vue-select'
import Calendar from 'v-calendar/lib/components/calendar.umd'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import moment from 'moment'
const ES = require("flatpickr/dist/l10n/es.js").default.es;

export default {
  data () {
    return {
    customQuestions: [],
    customQuestionsAnswers: [],
    timeSTR: "",
    dateStringOptions:  { weekday: 'short', year: 'numeric', month: 'short', day: 'numeric' },
    timeStringOptions:  { hour: 'numeric', minute: 'numeric', hour12: true },
    currentDoctorData: {},
    currentPatientData: {},
    loading1: true,
    loading2: true,
    consultationDetail: {
        comments_obs: null,
        diseases: [],
        medicaments: [],
        evaluationQuestions: [],
        importantNotes: null,
        physical_exam: null,
        vitalSigns: [],
        vitalSignsArr: [],
        physical_notes: null,
        previousConsultation: true,
        documents: [],
        cie10: [],
        exams: [],
        meds: [],
        usedMeds: [],
        diagnosis_eval: null,
        nextConsultation: {
          requestNext: false,
          whenQty: null,
          whenFrq: null,
        },
        consultationTotal: null,
        paymentMethod: null,
        main_symptoms: {
          pressure: false,
          fever: false,
          nausea: false,
          tiredness: false,
          fatigue: false
        }
      },
    eventData: {
        eventType: 'consultation',
        title: null,
        notes: null,
        duration: "60",
        notification: true,
        date: null,
        timeType: 'normal',
        clinic_id: null,
        patient_id: null,
        doctor_id: null,
        zoom_email: null,
        zoom_jwt: null,
        clinicType: 'presencial',
        hour: ""
    },
    configdateTimePicker: {
        enableTime: false,
        dateFormat: 'm-d-Y',
        altInput: true,
        altFormat: 'd M Y',
        // defaultDate: new Date(),
        minDate: new Date(),
        locale: ES
      },
    }
  },
computed: {
    activeClinic (){
        console.log(this.docClinics);

        var result = this.docClinics.find(obj => {
            return obj.id == this.eventData.clinic_id
        })
        if(result){
            return (result.title)
        } else {
            return ('')
        }
        
    },
    clinicAvailabilityByDate (){
      return this.$store.state.clinicAvailabilityByDate
    },
    availability (){
      return this.$store.state.schedule
    },
    docClinics () {
      let currentClinics = this.$store.state.clinics;
      console.log('CLINICAS:',currentClinics);
      // obtener clinicas virtuales de zoom y que esten activas
      var zoomClinics = this.findZoomClinicsActive();

      if (zoomClinics.length > 0){
        return currentClinics;
      } else {
        // si no ha activado 
        // let defaultVirtual = new Object();
        // defaultVirtual.title = 'Clinica Virtual Zoom',
        // defaultVirtual.meta = {"type":"Virtual", "zoom_active":"false"}
        // return [defaultVirtual, ...currentClinics];
        return currentClinics;
      }
    },
    currentPatient () {
        return this.$store.state.publicPatient;
    },
},
  methods: {
    openLoading(){
      this.$vs.loading()
      setTimeout( ()=> {
        this.$vs.loading.close()
      }, 10000);
    
    },
    convertUTC_TIME(dateSTR){
      var d = new Date(dateSTR);
      var time = d.getHours();
      return ("00" + time).slice(-2) + ":" +("00" + d.getMinutes()).slice(-2) + `${time > 12 ? "PM": "AM"}`
    },
    getClinicNaAd (clinic_id){
        console.log(this.docClinics);

        var result = this.docClinics.find(obj => {
            return obj.id == clinic_id
        })
        if(result){
            return [
                result.title,
                result.address,
                result.phone[0] ? result.phone[0] : '',
                result.address_2 ? result.address_2 : '',
                result.city ? result.city : '',
                result.country ? result.country : '',
                ]
        } else {
            return ['','']
        }
        
    },
    getDateTimeTxt(){
        var tempDate = new Date(this.eventData.date.replace(/-/g, "/"));
        console.log(tempDate);
        tempDate.setHours(this.eventData.hour.split(':')[0],this.eventData.hour.split(':')[1].substring(0,2));
        // tempDate.toISOString();
        var dateStr = tempDate.toLocaleDateString('es-ES', this.dateStringOptions),
         timeStr =   tempDate.toLocaleTimeString('en-EN', this.timeStringOptions);
        this.timeSTR = dateStr + ' a las ' + timeStr;
    },
    findZoomClinicsActive(){
      let zoomClinics = this.$store.state.clinics.filter(obj => {
        return ( obj.meta.type && obj.meta.type.toLowerCase() == 'virtual' )
          
          && (obj.meta.zoom_email)
          && (obj.meta.zoom_active && obj.meta.zoom_active.toLowerCase() == 'true');

      });
      console.log(zoomClinics);
      return zoomClinics
    },
    scroll(){
       window.scroll({
        top: 50,
        left: 0,
        behavior: 'smooth'
      });
    },
    firstStep(){
         return new Promise((resolve, reject) => {
            setTimeout(() => {
                this.scroll();
                resolve(true);
            }, 100);
        });
    },
    validateCitaMed(){
        return new Promise((resolve, reject) => {
            this.$validator.validateAll('cita-med').then(result => {
                if (result) {
                    this.getDateTimeTxt();
                    this.scroll();
                    resolve(true);
                } else {
                    reject('correct all values')
                }
            })
        });
    },
    getWeekDays() {
      if(this.currentDoctorData) {
        if(this.currentDoctorData.meta && this.currentDoctorData.meta.weekDays) {
          const weekDays = this.currentDoctorData.meta.weekDays;
          return Array.isArray(weekDays) ? weekDays : null
        }
      }
      return null;
    },
    getSchedule(currentDate) {
      let day = moment(currentDate, 'MM-DD-YYYY').day();
      day = day == 0 ? 7 : day;
      const weekDays = this.getWeekDays();
      return weekDays ? weekDays.find(item => item.id ==day) : null;
    },
    formSubmitted () {
      this.addEvent();
    },
    getFormattedDate(date) {
      var year = date.getFullYear();

      var month = (1 + date.getMonth()).toString();
      month = month.length > 1 ? month : '0' + month;

      var day = date.getDate().toString();
      day = day.length > 1 ? day : '0' + day;
      
      return month + '-' + day + '-' + year;
    },
    addEvent(){
        this.openLoading();
        console.log(this.eventData);
        let newEventObj = new Object();
        newEventObj.type = 'consultation',
        newEventObj.clinic_id = this.eventData.clinic_id,
        newEventObj.patient_id = this.$route.params.user_id,
        newEventObj.doctor_id = this.$route.params.doctor_id,
        newEventObj.meta = {"status": "Solicitud"},
        newEventObj.duration = this.currentDoctorData.meta.consultationLength ? this.currentDoctorData.meta.consultationLength : 60,
        newEventObj.title = `Cita con ${this.currentPatient.first_name} ${this.currentPatient.last_name} ` ,
        newEventObj.notification = true;
        newEventObj.clinic_address = this.getClinicNaAd(this.eventData.clinic_id)[0];
        newEventObj.clinic_name = this.getClinicNaAd(this.eventData.clinic_id)[1];
        newEventObj.clinic_phone = this.getClinicNaAd(this.eventData.clinic_id)[2];
        newEventObj.clinic_address_2 = this.getClinicNaAd(this.eventData.clinic_id)[3];
        newEventObj.clinic_city = this.getClinicNaAd(this.eventData.clinic_id)[4];
        newEventObj.clinic_country = this.getClinicNaAd(this.eventData.clinic_id)[5];
        
        newEventObj.patient_first_name = this.currentPatient.first_name;
        newEventObj.patient_last_name = this.currentPatient.last_name;
        newEventObj.patient_email = this.currentPatient.email;
        newEventObj.doctor_first_name = this.currentDoctorData.first_name;
        newEventObj.doctor_last_name = this.currentDoctorData.last_name;

        var customQuestionsContainer = new Array();
        for (let index = 0; index < this.customQuestions.length; index++) {
            let tempObj = new Object();
            tempObj.name = this.customQuestions[index].name;
            tempObj.title = this.customQuestions[index].title;
            tempObj.instructions = this.customQuestions[index].placeholder;
            tempObj.active = this.customQuestions[index].active;
            tempObj.answer = this.customQuestionsAnswers[index];
            customQuestionsContainer.push(tempObj);
        }


        newEventObj.meta = {...newEventObj.meta, ...this.consultationDetail, ...{'customQuestions': customQuestionsContainer}};
        console.log(this.eventData.date);
        var d = new Date(this.eventData.date.replace(/-/g, "/"));
        // console.log(tempDate);
        d.setHours(this.eventData.hour.split(':')[0],this.eventData.hour.split(':')[1].substring(0,2));
        // newEventObj.date = tempDate.toISOString();
        newEventObj.date = d.getFullYear()+ "-" + ("00" + (d.getMonth() + 1)).slice(-2) + "-" +("00" + d.getDate()).slice(-2)+"T"+ ("00"  + (d.getUTCHours()-6)).slice(-2) + ":" +("00" + d.getUTCMinutes()).slice(-2) + ":" + ("00" + d.getSeconds()).slice(-2)
        // return true;
        this.$store.dispatch('addEventPublic',newEventObj, true).then(response => {
            console.log(response);
            this.$store.dispatch('notifyConfirmSuccess', response).then((response2) => {
                // window.location.href = '/links/confirm-s';  
                console.log('notify success');
            }).catch((error) => { 
                    // window.location.href = '/links/confirm-s';   
                    console.log(error);
                });

            var notifPayload = JSON.stringify(
                    {
                    "type":"push",
                    "title":"Nueva consulta #"+response.data.data.event.id+" !",
                    "message": `La consulta #${response.data.data.event.id} fue agregada por el paciente: 
                        ${this.currentPatientData.first_name}  ${this.currentPatientData.last_name} con ID # ${this.currentPatientData.id}`,
                    "target":{
                        "id":{"$eq":""+response.data.data.event.doctor_id+""}
                        }
                });
            
            
                // ---------------------
                const dateStringOptions =  { weekday: 'short', year: 'numeric', month: 'short', day: 'numeric' };
                const timeStringOptions =  { hour: 'numeric', minute: 'numeric', hour12: true };
                
                this.$store.dispatch('sendNotificationPublic', notifPayload).then((response2) => {
                    // 
                    var notifPayload2 = 
                    {
                    type:"email",
                    title:"Consulta #"+response.data.data.event.id+" agendada éxitosamente !",
                    patient_email: this.currentPatientData.email,
                    event_id: response.data.data.event.id,
                    patient_name: this.currentPatientData.first_name+' '+this.currentPatientData.last_name,
                    doctor_name: this.currentDoctorData.first_name+' '+this.currentDoctorData.last_name,
                    date_time: new Date(response.data.data.event.date).toLocaleDateString('es-ES', dateStringOptions)+' a las '+
                    new Date(response.data.data.event.date).toLocaleTimeString('en-EN', timeStringOptions),
                    phone: this.currentPatientData.phone,
                    hour: new Date(response.data.data.event.date).toLocaleTimeStirng('en-EN', timeStringOptions)
                    }

                    this.$store.dispatch('notifyNewConsultationScheduled', notifPayload2).then((response3) => {
                       window.location.href = '/links/confirm-s';  
                    }).catch((error) => {
                        window.location.href = '/links/confirm-s';   
                        console.log(error)
                    });
                    //  
                }).catch((error) => { 
                    window.location.href = '/links/confirm-s';   
                    console.log(error)
                });
        }, error => {
            console.error(error);
        });
    }
  },
  beforeCreate(){
    this.$store.dispatch('fetchClinicsPublic', this.$route.params.doctor_id);
    console.log(this.$route);
    this.$store.dispatch('getUserDataByIdPublic', this.$route.params.user_id).then(response => {
        console.log(response);
        this.currentPatientData = JSON.parse(JSON.stringify(response.data.data.user));
        this.loading1 = false;
        
        }, error => {
            console.error(error);
        }
    );
    this.$store.dispatch('getUserDataByIdPublic', this.$route.params.doctor_id).then(response => {
        console.log(response);
        this.currentDoctorData = JSON.parse(JSON.stringify(response.data.data.user));
        this.eventData.duration = this.currentDoctorData.meta.consultationLength ? this.currentDoctorData.meta.consultationLength : 60 ;
        // dynamic questions
        if(this.currentDoctorData.meta.consultation_questions){
            this.customQuestions = JSON.parse(JSON.stringify(this.currentDoctorData.meta.consultation_questions))
            this.customQuestionsAnswers = new Array(this.customQuestions.length);
            this.consultationDetail.consultationTotal =  this.currentDoctorData.meta.defaultPrice;
            
        }
        // 
        this.loading2 = false;
        this.$store.dispatch('fetchEventsPublic', this.$route.params.doctor_id).then(response => {
            console.log(response);
        }, error => {
            console.error(error);
        }); 
    }, error => {
        console.error(error);
    }
    );
},
created() {
    var schedulePayload = new Object();
    schedulePayload.date = this.getFormattedDate(new Date());

    this.$store.dispatch('buildSchedule', schedulePayload).then(response => {
        console.log(response);
    }, error => {
        console.error(error);
    }); 
},
watch: {
    'eventData.date': function(newVal, oldVal) {
      // creating request payload
      console.log(newVal);
      try {
          var DateSelected = new Date(newVal.replace(/-/g, "/"));
          var DateAfter = new Date(DateSelected);
      } catch (error) {
          var DateSelected = new Date(newVal);
          var DateAfter = new Date(DateSelected);
          console.error(error);
      }
      
      DateAfter.setDate(DateAfter.getDate()+1);
      this.eventData.hour = null;
      
      // -------- fetching clinic schedule by date --------
      var fetchClinicSchedule_payload = new Object();
      fetchClinicSchedule_payload.clinic_id = this.eventData.clinic_id,
      fetchClinicSchedule_payload.start_date = DateSelected.toISOString().split('T')[0]+'T06:00',
      fetchClinicSchedule_payload.end_date = DateAfter.toISOString().split('T')[0]+'T05:59',
      fetchClinicSchedule_payload.requestDate = new Date().toISOString().substring(0,16),
      fetchClinicSchedule_payload.eventLength = this.eventData.duration;
      fetchClinicSchedule_payload.doctor_id = this.$route.params.doctor_id;

      if(this.eventData.clinic_id && this.eventData.duration){
        console.log(fetchClinicSchedule_payload)
        this.$store.dispatch('fetchClinicSchedulePublic', fetchClinicSchedule_payload).then(response => {
          console.log('RESPONSE: ',response);
        }, error => {
            console.error(error);
        }); 
      }
    },
    'eventData.clinic_id': function(newVal, oldVal) {
      let currClinic = this.$store.state.clinics.filter(obj => {
        return ( obj.id  ==  newVal )
      });
      this.currClinic =  currClinic[0];
      console.log(this.currClinic)
    }},
components: {
    FormWizard,
    TabContent,
    Datepicker,
    vSelect,
    Calendar,
    flatPickr
  }
}
</script>
<style scoped>
body{
        touch-action: manipulation;
    }
</style>
<style>
.style-chooser .vs__dropdown-menu {
    max-height: 200px;
  }
</style>